// extracted by mini-css-extract-plugin
export default {"transitionTime":"50ms","iconSearch":"E18U0C","label":"dYdz1G","labelEnter":"DZJuX7","labelLeave":"np5q7I","labelEnterDone":"kL8lnX","labelLeaveActive":"Y0JUnF"};